const checkboxStyle = `appearance-none h-4 w-4 border border-gray-300 rounded-sm bg-white
                            checked:bg-primary checked:border-primary focus:outline-none transition
                            duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-2 cursor-pointer`;

export {
    checkboxStyle
}